import React from "react"
import CreatableSelect from "react-select/creatable"
import { Mutation, Query } from "react-apollo"
import gql from "graphql-tag"

class CategorySelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedOptions: props.selectedOptions,
    }
  }

  getValue = () => {
    return {
      type: "category-select-component",
      props: {
        selectedOptions: this.state.selectedOptions,
      },
    }
  }

  handleChange = (options) => {
    this.setState({ selectedOptions: options || [] })
  }

  handleCreate = async (val) => {
    try {
      await this.props.createCategory({
        variables: {
          name: val,
        },
      })
      let options = this.state.selectedOptions
      options.push({ value: val, label: val })
      this.setState({ selectedOptions: options })
    } catch (error) {
      console.log("error: ", error)
    }
  }

  render() {
    let categories = this.props.categories
    if (!categories) {
      categories = [{ name: "" }]
    }
    let catOptions = categories.map((elem) => {
      return { value: elem.name, label: elem.name }
    })
    return (
      <div>
        <CreatableSelect
          isMulti
          name="colors"
          placeholder="Select all related categories"
          value={this.state.selectedOptions}
          options={catOptions}
          onChange={this.handleChange}
          onCreateOption={this.handleCreate}
        />
      </div>
    )
  }
}

const GET_CATEGORIES = gql`
  query Get_Categories($name: String!) {
    categories(name: $name) {
      id
      name
    }
  }
`
const CREATE_CATEGORIES = gql`
  mutation Create_Categories($name: String!) {
    createCategory(name: $name) {
      payload
      message
    }
  }
`
// eslint-disable-next-line react/display-name
const CategorySelectWithData = React.forwardRef((props, ref) => (
  <Mutation
    mutation={CREATE_CATEGORIES}
    refetchQueries={[{ query: GET_CATEGORIES, variables: { name: "" } }]}
  >
    {(createCategory) => {
      return (
        <Query
          query={GET_CATEGORIES}
          variables={{ name: "" }}
          fetchPolicy="network-only"
        >
          {({ loading, error, data }) => {
            if (loading) return "Loading..."
            if (error) return `Error! ${error.message}`
            return (
              <CategorySelect
                createCategory={createCategory}
                {...data}
                ref={ref}
                {...props}
              />
            )
          }}
        </Query>
      )
    }}
  </Mutation>
))

export default CategorySelectWithData
